import axios from "@axios";
import store from "@/store";
import {useUtils as useI18nUtils} from "@core/libs/i18n";

export default {
  namespaced: true,
  state: {
    items: [],
    selectAll: false
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(camera => ({
        value: camera.id,
        label: camera.name,
      }))
    },
    getSelectAll(state) {
      return state.selectAll
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
    setSelectAll(state, value) {
      state.selectAll = value;
    },
  },
  actions: {
    async export({commit}, params) {
      const response = await axios.get("v1/vxg_camera", {
        params,
        responseType: params?.action == "export" ? "blob" : "json",
      });
      if (!response.data) {
        return [];
      }
      if (params?.action == "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        const {t} = useI18nUtils();

        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "Vxg camaras",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Reporte de Vxg camaras",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else {
        commit("setData", response.data.data);
        return response.data;
      }
    },
    async getAll({commit}, params) {
      const {data} = await axios.get('v1/vxg_camera', {params})

      if (!data.success) {
        return []
      }
      commit('setData', data.data)
      return data
    },
    async get(_, {id}) {
      const {data} = await axios.get(`v1/vxg_camera/${id}`)

      return data
    },
    async updateStreamConfiguration(_, params) {
      const {data} = await axios.put('v1/vxg_camera/updateStreamConfiguration', params)

      return data
    },
    async updateStatus(_, {id}) {
      const {data} = await axios.get(`v1/vxg_camera/update_streams/${id}`)
      return data
    },
    async add(_, params) {
      const {data} = await axios.post('v1/vxg_camera', params)

      return data
    },
    async edit(_, {id, params}) {
      const {data} = await axios.put(`v1/vxg_camera/${id}`, params)

      return data
    },
    async delete(_, {id, params}) {
      const {data} = await axios.delete(`v1/vxg_camera/${id}`, {delete: 'VXG'})

      return data
    },
    async deleteAllCameras(_, params) {
      const {data} = await axios.get(`v1/vxg_camera/deleteVxgCameras`, {params} )

      return data
    },
    async getWebUi(_, id) {
      const {data} = await axios.get(`v1/omnicloud_camera/proxy/${id}`)

      return data
    },
    async updateDBCameras() {
      const {data} = await axios.get(`v1/mobile/updateCameras`)

      return data
    },
    async getVxgCameras(_, params) {
      const {data} = await axios.get(`v1/mobile/get/vxg_cameras`, {params})

      return data
    },
    async updateVxgCameras(_, params) {
      const {data} = await axios.post(`v1/mobile/update/vxg_cameras`, params)

      return data
    },
    clear({commit}) {
      commit('setData', [])
    }
  },
}
